import React, { useEffect } from 'react'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getGroupCourseBatchList } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';

const StudentTutorGroupBatchList = () => {
    const dispatch = useDispatch();
    const { b64id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        try {

            const courseId = atob(b64id);


            if (!courseId || isNaN(courseId)) {
                throw new Error("Invalid course ID");
            }


            dispatch(getGroupCourseBatchList(courseId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);



    const {

        loadingGroupCourseBatchListApi,
        GroupCourseBatchListApiData,
        GroupCourseBatchListApiError,

    } = useSelector(state => state?.StudentReducer);

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Group Course Batches
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="view-group-courses">
                                    <h4 className="mb-3">View Group Course Batches</h4>
                                    {loadingGroupCourseBatchListApi ?
                                        <Beatloader />
                                        :
                                        <div className="row">
                                            {GroupCourseBatchListApiData?.length > 0 ?
                                                GroupCourseBatchListApiData?.map((data) => (
                                                    <div className="col-lg-6 mt-3 col-md-6" key={data?.id}>
                                                        <div className="card input-card-form bg-white">
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <p className="fw-bold mb-0">Max. Students : {data?.max_no_of_student}</p>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <p className="fw-bold mb-0 text-end">
                                                                            Enroll Students : {data?.current_enrollment ? data?.current_enrollment : 0}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-12">
                                                                        <p className="fw-bold mb-0">Batch Name : {data?.batch_name}</p>
                                                                        <p className="fw-bold mb-0">Batch Start : {data?.batch_start_date}</p>
                                                                        <p className="fw-bold mb-0">Batch End : {data?.batch_end_date}</p>
                                                                    </div>
                                                                </div>
                                                                <Link to={`/student/group-batch-session/${btoa(data?.id)}`}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary w-100 my-3"

                                                                    >
                                                                        View Session
                                                                    </button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                                :
                                                <div className='no-data-img'>
                                                    <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                </div>
                                            }
                                        </div>}
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>



        </div>
    )
}

export default StudentTutorGroupBatchList